import { TYPES } from "./default_computer.type";
import { onSnapshot, query, limit } from "firebase/firestore";
//func
import { getRefs } from "../ref";
import { getApiFunctions } from "store/bailiff/api";

// ========= firebase function =========//

//snap all provider
const allDefaultComputerSub = [];
export const snapDefaultComputer = (callback) => (dispatch) => {
  setDefaultComputerAllSuccess(dispatch, null);
  const cRef = getRefs().computer;
  const c0 = limit(1000);
  const qRef = query(cRef, c0);
  const unsub = onSnapshot(qRef, (snapshot) => {
    if (snapshot) {
      const data = snapshot.docs.map((doc) => doc.data());
      setDefaultComputerAllSuccess(dispatch, data);
      if (callback) {
        callback();
      }
    }
  });
  allDefaultComputerSub.push(unsub);
};

export const unSnapDefaultComputer = () => (dispatch) => {
  allDefaultComputerSub.forEach((subscriber) => {
    subscriber();
  });
  allDefaultComputerSub.length = 0;
};
// ========= cloud function =========//
export const cloudAddMachine =
  ({ worker }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.addMachine;
    const options = { worker };
    console.log({ options });
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

export const cloudUpdateStatusMachine =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.updateStatusMachine;
    const options = { id };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

export const cloudDeleteMachine =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.deleteMachine;
    const options = { id };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

export const cloudForceCloseMachine =
  ({ id }, callback) =>
  (dispatch) => {
    const functions = getApiFunctions().operator.forceCloseMachine;
    const options = { id };
    functions(options)
      .then(() => {
        callback && callback({ status: 200 });
      })
      .catch((err) => {
        console.log({ err });
        callback &&
          callback({ status: 500, data: err?.message || "Please try again!" });
      });
  };

// ========= local function =========//
export const setDefaultComputerAll = (data, callback) => (dispatch) => {
  setDefaultComputerAllSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultComputerSelected = (data, callback) => (dispatch) => {
  setDefaultComputerSelectedSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

export const setDefaultComputerOpenAdd = (data, callback) => (dispatch) => {
  setDefaultComputerOpenAddSuccess(dispatch, data);
  if (callback) {
    callback();
  }
};

// ========= dispatch =========//

const setDefaultComputerAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_COMPUTER_ALL,
    payload: data,
  });
};

const setDefaultComputerSelectedSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_COMPUTER_SELECTED,
    payload: data,
  });
};

const setDefaultComputerOpenAddSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SET_DEFAULT_COMPUTER_OPEN_ADD,
    payload: data,
  });
};
